import { useState } from "react";
import {
  BeaconTableColumns,
  SCBOneDeviceOrganization,
  SCBOneDevicesTableSorting,
} from "../../api";
import { useSCBOneOrganizationDevices } from "../../api/api.scb-one";
import { BeaconTableBase } from "../../components/BeaconTableBase";
import { OrganizationSCBOneDeviceTableFooter } from "./OrganizationSCBOneDeviceTableFooter";

interface OrganizationSCBOneDevicesTableTableProps {
  organizationId: string;
}

const useSorting = () => {
  const [sorting, setSorting] = useState<SCBOneDevicesTableSorting>({
    sortColumnId: undefined,
    sortOrderId: undefined,
  });

  const onSortingChange = (sorting: SCBOneDevicesTableSorting) => {
    setSorting(sorting as SCBOneDevicesTableSorting);
  };

  return { sorting, onSortingChange };
};

const useSelectedDevices = () => {
  const [selectedDeviceSerials, setSelectedDeviceSerials] = useState<string[]>(
    []
  );

  const onSelect = (selectedRowKeys: string[]) => {
    setSelectedDeviceSerials(selectedRowKeys);
  };

  const clearSelectedBeaconIds = () => {
    setSelectedDeviceSerials([]);
  };

  return { selectedDeviceSerials, onSelect, clearSelectedBeaconIds };
};

export function OrganizationSCBOneDevicesTable({
  organizationId,
}: OrganizationSCBOneDevicesTableTableProps) {
  const { sorting, onSortingChange } = useSorting();
  const { selectedDeviceSerials, onSelect, clearSelectedBeaconIds } =
    useSelectedDevices();
  const scbOneDevices = useSCBOneOrganizationDevices(organizationId, sorting);

  return (
    <BeaconTableBase<SCBOneDeviceOrganization, SCBOneDevicesTableSorting>
      beaconData={scbOneDevices}
      tableType="scb-one"
      visibleColumns={[
        BeaconTableColumns.Serial,
        BeaconTableColumns.Status,
        BeaconTableColumns.ConfigurationButton,
      ]}
      sortableColumns={[BeaconTableColumns.Serial]}
      showSorter={true}
      onSort={onSortingChange}
      rowsSelectable={true}
      showClearSelected={true}
      onSelect={onSelect}
      showFooter={true}
      footerContent={
        <OrganizationSCBOneDeviceTableFooter
          {...{ organizationId, selectedDeviceSerials }}
          onClearSelectedBeaconIds={clearSelectedBeaconIds}
        />
      }
    />
  );
}
